<template>
    <div class="camping-location" v-if="campingDetail && campingDetail.acf">
        <div class="container">
            <div class="row">
                <div class="col-sm-6 font-bai">
                    <h2>{{ campingDetail.acf.camsi_title }}</h2>
                    <ul
                        class="list-inline camping-svlist font-bold"
                        v-if="campingDetail.acf.camsi_list.length > 0"
                    >
                        <li
                            class="item-inline"
                            v-for="(item, index) in campingDetail.acf
                                .camsi_list"
                            :key="index"
                        >
                            <a
                                href=""
                                @click.prevent
                                class="text-center svitem font-bai"
                            >
                                <div class="image">
                                    <img :src="item.icon" :alt="item.title" />
                                </div>
                                <div v-html="item.title"></div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="col-sm-6 font-bai">
                    <div class="camping-map">
                        <h2>{{ $t("app.localisation") }}</h2>
                        <div
                            id="campingMap"
                            v-html="campingDetail.acf.cam_google_map"
                        >
                            <!-- <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d83998.75769515168!2d2.277020492155876!3d48.85895068065112!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e1f06e2b70f%3A0x40b82c3688c9460!2zUGEgcmksIFBow6Fw!5e0!3m2!1svi!2s!4v1588937855520!5m2!1svi!2s"
                                width="600"
                                height="450"
                                frameborder="0"
                                style="border:0;"
                                allowfullscreen=""
                                aria-hidden="false"
                                tabindex="0"
                            ></iframe> -->
                        </div>
                        <p v-html="campingDetail.acf.cam_address">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { get } from "lodash";
export default {
    name: "CampingLocation",
    computed: {
        ...mapState({
            campingDetail: state => get(state, "campingClubs.detail", null)
        })
    },
    mounted() {
        console.log(this.campingDetail);
    }
};
</script>
